var render = function render(){var _vm=this,_c=_vm._self._c;return _c('consumer-loan-form',{attrs:{"errors":_vm.errors,"loading":_vm.storing,"submit-label":"Save"},on:{"submit":_vm.update},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})
}
var staticRenderFns = []

export { render, staticRenderFns }